import React, { useState, useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import 'moment/min/locales'
import { isEmpty } from 'lodash'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { GeneralContext } from '../../../context/'
import GeneralList from '../../../components/Common/GeneralList'
import ApiService from '../../../data/services/ApiService'

moment.locale('es')
const LIMIT = 20

const Datatable = (props) => {
  const generalContext = useContext(GeneralContext)
  const { setLoading } = generalContext

  const [list, setList] = useState([])
  const [offset, setOffset] = useState(0)
  const [totalCount, setTotalCount] = useState(0)
  const [filter, setFilter] = useState([])
  const [deleteModal, setDeleteModal] = useState(false)
  const [removeItem, setRemoveItem] = useState({})

  const toggleDeleteModal = () => setDeleteModal(!deleteModal)

  const fetchData = async () => {
    setLoading(true)
    const response = await ApiService.getUserAddress(offset, LIMIT, filter)
    setList(response.data.data)
    setTotalCount(response.data.count)
    setLoading(false)
  }

  useEffect(() => {
    (async function fetch() {
        await fetchData()
    })()
  }, [offset, filter]) // eslint-disable-line

  const handleCreateButton = () => {
    props.history.push('/direcciones-envio/agregar')
  }

  const edit = (item) => {
    props.history.push(`/direcciones-envio/editar/${item.id}`)
  }

  const remove = async () => {
    toggleDeleteModal()
    setLoading(true)
    const response = await ApiService.deleteUserAddress(removeItem.id).catch(error => {
      toastr.error(`No pude eliminar la dirección de envío ${error}`, 'Error')
      return
    })
    if (!isEmpty(response.data)) {
      if (response.data.success) {
        toastr.success(`La dirección de envío fue eliminada.`, '¡Éxito!')
        await fetchData()
      }
    }
  }

  const handleMenuItemSelected = (itemIndex, optionIndex) => {
    const item = list[itemIndex]
    if (optionIndex === 0) {
      edit(item)
    } else if (optionIndex === 1) {
      toggleDeleteModal()
      setRemoveItem(item)
    }
  }

  return(
    <React.Fragment>
      <GeneralList
        columns={[
          { name: 'id', title: 'id' },
          { name: 'default', title: 'Default', disableFilter: true },
          { name: 'calle', title: 'Calle', placeholder: 'Calle...' },
          { name: 'numeroExterior', title: 'No. Ext', disableFilter: true },
          { name: 'numeroInterior', title: 'No. Int', disableFilter: true },
          { name: 'colonia', title: 'Colonia', placeholder: 'Colonia...' },
          { name: 'cp', title: 'CP', placeholder: 'CP' },
          { name: 'entreCalles', title: 'Entre calles', placeholder: 'Entre calles...' },
          { name: 'localidad', title: 'Localidad', placeholder: 'Localidad...' },
          { name: 'municipio', title: 'Municipio', placeholder: 'Municipio...' },
          { name: 'state', title: 'Estado', disableFilter: true },
          { name: 'country', title: 'País', disableFilter: true },
          { name: 'menu', title: ' ', disableFilter: true }
        ]}
        columnExtensions={[
          { columnName: 'default', width: 90 },
          { columnName: 'calle', width: 180 },
          { columnName: 'numeroExterior', width: 90 },
          { columnName: 'numeroInterior', width: 90 },
          { columnName: 'colonia', width: 160 },
          { columnName: 'cp', width: 90 },
          { columnName: 'entreCalles', width: 160 },
          { columnName: 'localidad', width: 160 },
          { columnName: 'municipio', width: 160 },
          { columnName: 'state', width: 120 },
          { columnName: 'country', width: 120 },
          { columnName: 'menu', width: 90 },
        ]}
        hiddenColumnNames={['id']}
        rows={list.map(item =>({
          ...item,
          default: (
            <React.Fragment>
              {item.default && (
                <div>
                  <i className="mdi mdi-check-circle font-size-24" style={{ color: 'green' }}></i>
                </div>
              )}
            </React.Fragment>
          ),
          state: item.state.nomEstado,
          country: item.country.nameEn,
        }))}
        showCreateButton
        createButtonText="Agregar dirección de envío"
        onClickCreateButton={handleCreateButton}
        onPageChanged={newPage => setOffset(newPage * LIMIT)}
        totalCount={totalCount}
        limit={LIMIT}
        optionsMenu={
          [
            {
              name: 'Editar',
              icon: 'mdi-pencil text-success'
            },
            {
              name: 'Eliminar',
              icon: 'mdi-trash-can text-danger'
            }
          ]
        }
        onMenuItemSelected={handleMenuItemSelected}
        showFilterRow
        onFiltersChange={f => {
          setFilter(f)
        }}
      />
      <div>
        <Modal isOpen={deleteModal} toggle={toggleDeleteModal}>
          <ModalHeader toggle={toggleDeleteModal}>Eliminar dirección de envío</ModalHeader>
          <ModalBody>
            ¿Está seguro que desea eliminar la dirección de envío?
          </ModalBody>
          <ModalFooter>
            <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={toggleDeleteModal}>Cancelar</Button>{' '}
            <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={remove}>Confirmar</Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Datatable)
